const baseURL = 'https://ccich.box504.com/';

export default baseURL;
